import GiftIcon from '../../images/icon-purchase-gift.svg'

export const PurchaseButtonIcon = () => {
    return <img src={GiftIcon} alt="icon" style={{position:'relative', top: '5%', right: '2%'}}/>
}
